import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Stack, Typography } from 'libs/ui';

import {
  dateOfBirthMaxDate,
  dateOfBirthMinDate,
  Field,
  useFormContext,
} from '../../../forms/createClientForm';

export const Representative = () => {
  const { t } = useTranslation();

  const { values } = useFormContext();

  return (
    <Stack spacing={12}>
      <Stack alignItems="center" direction="row" spacing={12}>
        <Typography variant="subtitle">
          {t('client.createClient.representative')}
        </Typography>

        <Stack alignItems="center" direction="row" spacing={8}>
          <Typography variant="caption">
            {t('client.createClient.missingRepresentative')}
          </Typography>

          <Field.Switch name="representative.missingRepresentative" />
        </Stack>
      </Stack>
      {!values.representative?.missingRepresentative && (
        <GridFields>
          <Field.Text
            fullWidth
            showRequiredMark
            autoComplete="off"
            label={t('client.createClient.fields.email.label')}
            name="representative.email"
            placeholder={t('client.createClient.fields.email.placeholder')}
          />

          <Field.Text
            fullWidth
            showRequiredMark
            label={t('client.createClient.fields.firstName.label')}
            name="representative.firstName"
            placeholder={t('client.createClient.fields.firstName.placeholder')}
          />
          <Field.Text
            fullWidth
            showRequiredMark
            label={t('client.createClient.fields.lastName.label')}
            name="representative.lastName"
            placeholder={t('client.createClient.fields.lastName.placeholder')}
          />
          <Field.Text
            fullWidth
            label={t('client.createClient.fields.middleName.label')}
            name="representative.middleName"
            placeholder={t('client.createClient.fields.middleName.placeholder')}
          />
          <Field.DatePicker
            fullWidth
            showRequiredMark
            label={t('client.createClient.fields.dateOfBirth.label')}
            maxDate={dateOfBirthMaxDate}
            minDate={dateOfBirthMinDate}
            name="representative.dateOfBirth"
            placeholder={t(
              'client.createClient.fields.dateOfBirth.placeholder'
            )}
          />

          <Field.Phone
            fullWidth
            showRequiredMark
            label={t('client.createClient.fields.phoneNumber.label')}
            maxLength={22}
            name="representative.phoneNumber"
            placeholder={t(
              'client.createClient.fields.phoneNumber.placeholder'
            )}
            type="phone"
          />
        </GridFields>
      )}
    </Stack>
  );
};
